import { IEditor, ISlugEntity } from '_/types/common.types';
import { IOrgEntity } from '_/types/organizations/organization.types';
import { ISnapshot } from '_/types/snapshots/snapshot.types';

export enum EDestinationType {
  AZURE = 'AZURE',
  S3 = 'S3',
  SFTP = 'SFTP',
}

export enum ECompressionType {
  GZIP = 'gzip',
  NONE = 'none',
  ZIP = 'zip',
}

interface IBaseDestinationConfig {
  filenameTemplate?: string;
  template?: string;
}

export interface IAzureConfig extends IBaseDestinationConfig {
  account: string;
  container: string;
}

export enum AzureCredentialsType {
  ACCOUNT_KEY = 'accountKey',
  SAS_TOKEN = 'sasToken',
}

export interface IAzureCredentials {
  [AzureCredentialsType.ACCOUNT_KEY]?: string;
  [AzureCredentialsType.SAS_TOKEN]?: never;
}

export interface IS3Config extends IBaseDestinationConfig {
  bucket: string;
}

export interface IS3Credentials {
  accessKeyId: string;
  secretAccessKey: string;
}

export interface ISFTPConfig extends IBaseDestinationConfig {
  host: number;
  port?: number;
}

export interface ISFTPCredentials {
  username?: string;
  password?: string;
  privateKey?: string;
}

export type TDestinationConfig = IAzureConfig | IS3Config | ISFTPConfig;

export type TEncryptedConfig = IAzureCredentials | IS3Credentials | ISFTPCredentials;

export interface IDestinationFiles extends Record<string, unknown> {
  json?: boolean;
  parquet?: boolean;
}

export interface CreateDestinationDTO<TConfig = Record<string, string>, TCredentials = Record<string, string>> {
  active: boolean;
  configuration: TConfig;
  encryptedConfig: TCredentials;
  files: IDestinationFiles;
  name: string;
  type: EDestinationType;
}

export type UpdateDestinationDTO = Partial<CreateDestinationDTO>;

export interface IDestination<TConfig = Record<string, string>, TCredentials = Record<string, string>>
  extends IOrgEntity, ISlugEntity, CreateDestinationDTO<TConfig, TCredentials> {}

export interface IDestinationPushMetadata {
  jsonUri?: string;
  customUri?: string;
  parquetUri?: string;
  customParquetUri?: string;
  jsonZipUri?: string;
  customZipUri?: string;
  archiveUri?: string;
}

export interface IDestinationPush {
  addedAt: Date;
  batchJobId: string;
  completedAt: Date;
  destinationId: string;
  error: Error | null;
  id: string;
  lastEditor: IEditor;
  lastEditorId: string;
  metadata: IDestinationPushMetadata | null;
  orgId: string;
  snapshotId: string;
  status: string;
  statusUpdatedAt: Date;
  updatedAt: Date;
  snapshot: ISnapshot;
  destination: IDestination;
}
